import { ZodSchema } from 'zod'

import { ErrorMonitoring } from '@/core/services/error-monitoring'

import { camelizeSchema } from './object'

export const parseResponse = <T extends ZodSchema>(
  schema: T,
  responseData: unknown,
) => {
  const { data, success, error } =
    camelizeSchema(schema).safeParse(responseData)

  if (!success) {
    console.error(error)
    ErrorMonitoring.captureException(error)

    throw error
  } else {
    return data
  }
}
